// @flow
import big from "big.js";

/**
 * @private
 */
const removeGroupingSeparator = (
  input: string | number,
  groupingSeparator?: ?string,
) => {
  if (typeof input === "number") {
    return input.toString();
  }

  if (groupingSeparator == null) {
    return input;
  }

  const escapedGroupingSeparator = groupingSeparator.replace(
    /[$()*+.?[\\\]^{|}]/g,
    // $FlowIssue
    String.raw`\$&`,
  );

  return input.replace(new RegExp(escapedGroupingSeparator, "g"), "");
};

/**
 * @private
 */
const updateDecimalSeparator = (
  input: string | number,
  decimalSeparator?: ?string,
) => {
  if (typeof input === "number") {
    return input.toString();
  }

  if (decimalSeparator == null || decimalSeparator === "") {
    return input;
  }

  return input.replace(decimalSeparator, ".");
};

/**
 * Parses input into a number, removes the grouping separator from the input and
 * replaces the decimal separator with a dot to make it a JavaScript parseable number
 */
const parseToNumber = (
  input: ?string | ?number,
  groupingSeparator: ?string = ",",
  decimalSeparator: ?string = ".",
): number => {
  if (input == null || input === "") {
    return NaN;
  }

  const inputNoGrouping = removeGroupingSeparator(input, groupingSeparator);

  const inputCorrectDecimalSeparator = updateDecimalSeparator(
    inputNoGrouping,
    decimalSeparator,
  );

  return Number(inputCorrectDecimalSeparator);
};

/**
 * parses Numbers To String
 */
const parseNumberToString = (
  input: ?string | ?number,
  groupingSeparator: ?string = ",",
  decimalSeparator: ?string = ".",
): string => {
  if (input == null || input === "") {
    return "NaN";
  }

  const inputNoGrouping = removeGroupingSeparator(input, groupingSeparator);

  const inputCorrectDecimalSeparator = updateDecimalSeparator(
    inputNoGrouping,
    decimalSeparator,
  );

  try {
    return big(inputCorrectDecimalSeparator).toFixed();
  } catch (error) {
    return "NaN";
  }
};

export { parseToNumber, parseNumberToString };
